module.exports = __webpack_public_path__ + "img/서브3_시야.7fdc34e5.svg";